import React from 'react';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';
import classnames from 'classnames';
import uniqueId from 'lodash/uniqueId';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import search from 'four-nets/icons/svg/icon_search.svg';

import defaultStyles from './search-input.scss';

interface Props {
    styles: typeof defaultStyles;
    placeholder?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => any;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => any;
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => any;
    iconWidth?: number;
    iconHeight?: number;
}

interface State {
    value: string;
    focused: boolean;
    searchInputId: string;
}

class SearchInput extends React.PureComponent<Props, State> {
    state = { value: '', focused: false, searchInputId: '' };

    componentDidMount() {
        this.setState({
            searchInputId: uniqueId('search-input-id'),
        });
    }

    onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (this.props.onChange) {
            this.props.onChange(e);
        }
        this.setState({ value: e.target.value });
    };

    onInputFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
        this.setState({ focused: true });
    };

    onInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
        this.setState({ focused: false });
    };

    render() {
        const { styles, placeholder, value, iconWidth, iconHeight } = this.props;
        const { value: internalValue, focused } = this.state;

        return (
            <div className={classnames(styles.searchInput, { [styles.focused]: focused })}>
                <span className={styles.iconWrapper}>
                    <SVGIcon src={search} style={{ image: styles.icon }} width={iconWidth} height={iconHeight} />
                </span>
                <FormattedMessage id='SEARCH_INPUT_PLACEHOLDER'>
                    {message => (
                        <React.Fragment>
                            <label htmlFor={this.state.searchInputId} className={styles.label}>
                                {message}
                            </label>
                            <input
                                id={this.state.searchInputId}
                                type='text'
                                className={styles.input}
                                placeholder={placeholder || (message as string)}
                                value={value || internalValue}
                                onChange={this.onChange}
                                onFocus={this.onInputFocus}
                                onBlur={this.onInputBlur}
                            />
                        </React.Fragment>
                    )}
                </FormattedMessage>
            </div>
        );
    }
}

export default Styled(defaultStyles)(SearchInput);
